<template>
  <div>
    <div class="greet bg_fff">
      <div class="greetContentL">
        <router-link class="routerLink" tag="a" to="/talent/greet">打招呼语</router-link>
        <router-link class="routerLink" tag="a" to="/talent/words">常用语</router-link>
      </div>
      <div class="greetContentR">
        <div class="pageTitle f_14 color_40">常用语设置</div>
        <ul class="commonWordList">
          <div v-for="(item, index) in wordsList" :key="index" class="wordItem color_40">
            <li class="wordDescription">{{ item }}</li>
            <div class="wordOperation">
              <button class="color_9c" @click="editWords(item, index)">编辑</button>
              <button class="color_9c" @click="deleteWords(item, index)">删除</button>
            </div>
          </div>
        </ul>
        <button class="commonWordBtn f_14" v-if="wordsList.length<10" @click="addCommonWords">添加常用语</button>
        <div class="maxlength pr" v-show="showTextInput">
          <el-input class="restInput color_60 f_14"
                    type="textarea" placeholder="请输入常用语文案" v-model="currentWord"
                    :autosize="{ minRows: 2, maxRows: 2}"
                    :maxlength="200" resize="none">
          </el-input>
          <div class="pa f_14 color_9c">{{currentWord.length}}/200</div>
        </div>
        <div class="templateButtons" v-show="showTextInput">
        	<div class="confirmButton text_center bg_cf color_fff f_14 cursor_p" v-if="getContentState">保存</div>
          <div class="confirmButton text_center color_fff f_14 cursor_p" v-else @click="saveCommonWords">保存</div>
        </div>
      </div>
    </div>
		<!-- 询问框 -->
    <MessageBox :pageData="MessageBoxData" v-if="MessageBoxState" @confirmButton="saveCommonWords" @cancelButton="MessageBoxState=false" />
  </div>
</template>

<script>
	import actions from '../../../actions/index'
	import { get_tUser } from '../../../utils/utils'
	import MessageBox from '@/components/block/MessageBox'
	export default {
		name: 'Index',
		data () {
			return {
				showTextInput: false,
				currentWord: '',
				activeIndex: null,
				operationType: '',
				wordsList: [],

				MessageBoxState:false,//是否显示删除框
        MessageBoxData:{
          title:'温馨提示',
          desc:'确定删除这个常用语吗？'
        },
			}
		},
		mounted () {
			this.getCommonExpressions()
		},
		computed: {
			userToken () {
				let { h_t } = get_tUser()
				return h_t
			},
			getContentState(){
				let currentWord = this._data.currentWord.trim();
				return !currentWord.length
			},
		},
		watch: {},
		components: {
			MessageBox,
		},
		methods: {
			// 编辑常用语
			editWords (item, index) {
				this.showTextInput = true
				this.currentWord = item
				this.activeIndex = index
				this.operationType = 'edit'
			},
			// 删除常用语
			deleteWords (item, index) {
				this.operationType = 'delete'
				this.activeIndex = index;
				//显示询问弹窗
				this.MessageBoxState = true;
			},
			// 获取常用语列表
			async getCommonExpressions () {
				let res = await actions.im.getCommonExpressions({
					user_token: this.userToken
				})
				if (res.code === 1000) {
					this.wordsList = res.data.b_content
				}
			},
			// 点击添加常用语
			addCommonWords () {
				this.currentWord = '';
				this.activeIndex = null
				this.operationType = 'create'
				this.showTextInput = true
			},
			// 保存常用语
			async saveCommonWords () {
				let wordsList = [], res = {}
				let { operationType, activeIndex, currentWord } = this;
				currentWord = currentWord.trim();
				if(!currentWord && operationType !== 'delete'){
					this.currentWord = currentWord;
					return
				}
				if (operationType === 'create') {
					wordsList = [ ...this.wordsList, currentWord ]
				} else if (this.operationType === 'edit') {
					wordsList = JSON.parse(JSON.stringify(this.wordsList))
					wordsList[activeIndex] = currentWord
				} else if (this.operationType === 'delete') {
					wordsList = wordsList = JSON.parse(JSON.stringify(this.wordsList))
					wordsList.splice(activeIndex, 1)
				}
				let payload = {
					user_token: this.userToken,
					content: wordsList,
					identity: 'b'
				}
				if (this.operationType === 'create') {
					res = await actions.im.createCommonExpressions(payload)
				} else {
					res = await actions.im.editCommonExpressions(payload)
				}
				if (res.code === 1000) {
					this.wordsList = wordsList
					this.showTextInput = false
					this.currentWord = '';
					//关闭询问弹窗
					this.MessageBoxState=false
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
  @import "./Index";
</style>
